import { useState } from 'react';
import { FaPlay, FaQuoteLeft } from 'react-icons/fa';

function VideoTestimonialsSection({ buyLink, onBuyClick }) {
  const [playingVideo, setPlayingVideo] = useState(null);

  const testimonials = [
    {
      id: 1,
      title: "3 Year Old Payment of 8 Lakhs",
      subtitle: "62 Months Old Recovered With Interest",
      videoUrl: "https://www.youtube.com/embed/0Dpq4NMY0N4",
      thumbnail: "https://img.youtube.com/vi/0Dpq4NMY0N4/maxresdefault.jpg",
      amount: "₹8 Lakhs",
      location: "Saharanpur"
    },
    {
      id: 2,
      title: "4 Yrs Old 2.5 Lakhs Received",
      subtitle: "By Implementing Payment Recovery Formula",
      videoUrl: "https://www.youtube.com/embed/5taPiepKsRw",
      thumbnail: "https://img.youtube.com/vi/5taPiepKsRw/maxresdefault.jpg",
      amount: "₹2.5 Lakhs",
      client: "By Manoj Murarka",
      company: "Manishankar Oils Pvt Ltd Jaipur"
    },
    {
      id: 3,
      title: "20 Lakhs Received",
      subtitle: "By Implementing Payment Recovery Formula",
      videoUrl: "https://www.youtube.com/embed/P2Ecv69I_08",
      thumbnail: "https://img.youtube.com/vi/P2Ecv69I_08/maxresdefault.jpg",
      amount: "₹20 Lakhs",
      client: "By Abhishek Gupta",
      company: "R.G Sales Delhi"
    },
    {
      id: 4,
      title: "Multiple Payments Recovered",
      subtitle: "Complete Payment Recovery System",
      videoUrl: "https://www.youtube.com/embed/qNUYjBumqpc",
      thumbnail: "https://img.youtube.com/vi/qNUYjBumqpc/maxresdefault.jpg",
      amount: "Success Story",
      client: "Verified Client",
      company: "B2B Business"
    }
  ];

  return (
    <section className="relative py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-slate-900 via-black to-slate-900 overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 bg-gradient-to-r from-amber-500/10 to-orange-500/10 border border-amber-500/30 rounded-full px-6 py-3 mb-6">
            <FaQuoteLeft className="text-amber-400 text-xl" />
            <span className="text-amber-400 font-bold text-lg">Real Success Stories</span>
          </div>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-4">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 via-orange-400 to-amber-400">
              Video Testimonials
            </span>
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Watch how business owners recovered their stuck payments using our proven formula
          </p>
        </div>

        {/* Videos Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-16">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.id}
              className="group relative bg-gradient-to-br from-slate-800/50 to-slate-900/50 rounded-2xl overflow-hidden border border-slate-700/50 hover:border-amber-500/50 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-amber-500/20"
            >
              {/* Video Container */}
              <div className="relative aspect-video bg-black">
                {playingVideo === testimonial.id ? (
                  <iframe
                    className="w-full h-full"
                    src={`${testimonial.videoUrl}?autoplay=1&rel=0`}
                    title={testimonial.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                ) : (
                  <>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent z-10"></div>
                    <img
                      src={testimonial.thumbnail}
                      alt={testimonial.title}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        // Fallback to hqdefault if maxresdefault fails
                        if (e.target.src.includes('maxresdefault')) {
                          e.target.src = e.target.src.replace('maxresdefault', 'hqdefault');
                        }
                      }}
                    />
                    {/* Play Button */}
                    <button
                      onClick={() => setPlayingVideo(testimonial.id)}
                      className="absolute inset-0 z-20 flex items-center justify-center group/play"
                      aria-label="Play video"
                    >
                      <div className="relative">
                        <div className="absolute inset-0 bg-amber-500/30 rounded-full blur-xl group-hover/play:bg-amber-500/50 transition-all duration-300 animate-pulse"></div>
                        <div className="relative w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center shadow-2xl group-hover/play:scale-110 transition-transform duration-300">
                          <FaPlay className="text-white text-xl sm:text-2xl ml-1" />
                        </div>
                      </div>
                    </button>
                    {/* Amount Badge */}
                    <div className="absolute top-4 right-4 z-20 bg-gradient-to-r from-green-500 to-emerald-600 text-white px-4 py-2 rounded-full font-black text-sm shadow-lg">
                      {testimonial.amount}
                    </div>
                  </>
                )}
              </div>

              {/* Content */}
              <div className="p-5 sm:p-6">
                <h3 className="text-lg sm:text-xl font-bold text-white mb-2 group-hover:text-amber-400 transition-colors">
                  {testimonial.title}
                </h3>
                <p className="text-sm text-slate-400 mb-3">
                  {testimonial.subtitle}
                </p>
                {testimonial.client && (
                  <div className="space-y-1">
                    <p className="text-sm text-amber-400 font-semibold">
                      {testimonial.client}
                    </p>
                    <p className="text-xs text-slate-500">
                      {testimonial.company}
                    </p>
                  </div>
                )}
                {testimonial.location && (
                  <p className="text-sm text-slate-500">
                    📍 {testimonial.location}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>

       
      </div>
    </section>
  );
}

export default VideoTestimonialsSection;
